// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"wp-content_themes_indigotree-theme-2025_assets_js_front-end_header_js":"e758c56af8c74f04316d","wp-content_themes_indigotree-theme-2025_assets_js_front-end_forms_js":"2f482401a6dd679a9d34"}[chunkId] + ".js";
};